/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Device_Id_RequiredInputs */

const vi_error_irrigation_device_id_required = /** @type {(inputs: Error_Irrigation_Device_Id_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu mã bộ tưới, vui lòng tải lại trang rồi thử lại.`)
};

/**

* @param {Error_Irrigation_Device_Id_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_device_id_required = /** @type {((inputs?: Error_Irrigation_Device_Id_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Device_Id_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_device_id_required(inputs)
});